// @flow

import type { CredentialResponse } from './webauthn';

const PAYMENT_TYPE_CODE = 'pix-jsr';
const OPERATION_AUTHENTICATION = 'authentication';

type AuthenticationPayload = {|
  +contract: string,
  +payment_type_code: string,
  +operation: string,
  +enrollment: {|
    +authentication: CredentialResponse,
  |},
|};

type BuildAuthenticationPayloadParams = {|
  +contract: string,
  +credentialData: CredentialResponse,
|};

export function buildAuthenticationPayload({
  contract,
  credentialData,
}: BuildAuthenticationPayloadParams): AuthenticationPayload {
  return {
    contract,
    payment_type_code: PAYMENT_TYPE_CODE,
    operation: OPERATION_AUTHENTICATION,
    enrollment: {
      authentication: credentialData,
    },
  };
}
